import React from "react";
import { useLanguage } from "../utils/LanguageContext";

const textContent = {
  fr: {
    contenu: "Personne de contact contenu",
    web: "Personne de contact technique",
    adresse: "Service de la mobilité (SMo)",
  },
  de: {
    contenu: "Kontaktperson Inhalt",
    web: "Kontaktperson Technik",
    adresse: "Amt für Mobilität (MobA)",
  },
};

export default function Contact() {
  const { language } = useLanguage();
  const t = textContent[language]; // convention courante : appeler ça "t"

  return (
    <div className="flex-grow">
      <div className="w-full max-w-screen-xl mx-auto p-4">
        <h2 className="text-2xl font-semibold mb-4">Contact</h2>
        <h3 className="font-semibold mb-4">{t.contenu}</h3>
        Luna Sartori <br />
        <address className="mb-4">
          <a href="mailto:luna.sartori@fr.ch">
            luna.sartori@fr.ch
            <br />
          </a>
        </address>
        <h3 className="font-semibold mb-4">{t.web}</h3>
        Bastien Chardonnens <br />
        <address className="mb-4">
          <a href="mailto:bastien.chardonnens@fr.ch">
            bastien.chardonnens@fr.ch
            <br />
          </a>
        </address>
        <address className="mb-4">
          <br />
          {t.adresse} <br />
          Grand-Rue 32
          <br />
          1701 Fribourg
          <br />T +41 26 304 14 33
        </address>
      </div>
    </div>
  );
}
